<template>
  <div id="experience-map-show">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <mapbox
                access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
                :map-options="mapOptions"
                @map-init="displayMarkers"
                :key="markers.length"
                ref="mapInstance"
            />
            <CategoryCardmap v-if="selectedMarker && selectedMarkerType === 'experience' && selectedLodging" :lodging="selectedLodging" :destination="selectedLodging.destination || selectedLodging" @unselect="unselectCardMap" :idMarker="selectedMarker" />
            <Cardmap v-if="selectedMarker && selectedMarkerType === 'lodging' && selectedLodging" :lodging="selectedLodging" @unselect="unselectCardMap" />
          </div>
        </div>
        <div class="closing">
          <button class="close-btn-modal" @click="$emit('close')">X</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';
import CategoryCardmap from '../components/cards/CategoryCardmap.vue';
import Cardmap from '../components/cards/Cardmap.vue';
import 'mapbox-gl/dist/mapbox-gl.css';
import fetcher from "../packs/shared/api.js";

export default {
  name: 'ExperienceMapShow',
  props: ['markers', 'currentExperiance', 'lodgings', 'currentLodging'],
  components: { Mapbox, CategoryCardmap, Cardmap },
  data() {
    return {
      mapOptions: {
        style: 'mapbox://styles/mapbox/streets-v10',
        zoom: 15,
        center: this.calculateCenter(),
      },
      selectedMarker: null,
      selectedLodging: null,
      previousZoom: null,
      previousCenter: null,
      isPhone: window.innerWidth < 768,
      nearbyLodgings: [],
      selectedMarkerType: 'experience', // Track whether selected marker is experience or lodging
    };
  },
  watch: {
    currentExperiance(newVal) {
      console.log("Updated currentExperiance:", newVal);
      if (this.$refs.mapInstance && this.$refs.mapInstance.map) {
        this.displayMarkers(this.$refs.mapInstance.map); 
      }
    }
  },
  beforeDestroy() {
    const stickyCard = document.getElementById('address-card-sticky');
    if (stickyCard) {
      stickyCard.style.display = 'block';
    }
  },
  mounted() {
    console.log("Markers Prop:", this.markers);
    console.log("Lodgings Prop:", this.lodgings);
    if (this.$refs.mapInstance && this.$refs.mapInstance.map) {
      this.displayMarkers(this.$refs.mapInstance.map);
    }
    const stickyCard = document.getElementById('address-card-sticky');
    if (stickyCard) {
      stickyCard.style.display = 'none';
    }
    
    // Fetch nearby lodgings if currentLodging is provided
    if (this.currentLodging && this.currentLodging.id) {
      this.fetchNearbyLodgings(this.currentLodging.id);
    }
  },
  methods: {
    async fetchNearbyLodgings(lodgingId) {
      try {
        const response = await fetcher.get(`/lodgings/${lodgingId}/nearby`);
        this.nearbyLodgings = [...response.data.nearby, this.currentLodging];
        console.log('Nearby lodgings fetched:', this.nearbyLodgings);
        
        // Re-render markers if map is already initialized
        if (this.$refs.mapInstance && this.$refs.mapInstance.map) {
          this.displayMarkers(this.$refs.mapInstance.map);
        }
      } catch (e) {
        console.error('Error fetching nearby lodgings:', e);
      }
    },
    calculateCenter() {
      if (!this.markers || this.markers.length === 0) {
        return this.currentLodging ? [this.currentLodging.longitude, this.currentLodging.latitude] : [2.3522, 48.8566]; // Default to current lodging or Paris
      }
      
      let latitudes = this.markers.map(marker => marker[1]);
      let longitudes = this.markers.map(marker => marker[0]);

      let centerLat = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
      let centerLng = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;

      return [centerLng, centerLat];
    },

    // Dynamic icon assignment based on current experience using S3 URLs
    getIconForExperience() {
      let normalizedExperience = this.currentExperiance.trim().toLowerCase(); // Normalize input

      let result;
      switch (normalizedExperience) {
        case "les expériences culturelles":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culturelles.svg";
          break;
        case "les expériences au naturel":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/au_nature.svg";
          break;
        case "les expériences au bord de l'eau":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/au_bord.svg";
          break;
        case "les expériences immersives":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/immersives.svg";
          break;
        case "les expériences culinaires":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culinaires.svg";
          break;
        case "les expériences diy":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/DIYS.svg";
          break;
        case "les expériences oenologiques":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/oenologiques.svg";
          break;
        case "les expériences sportives":
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/sportives.svg";
          break;
        default:
          console.log('Default case triggered for', normalizedExperience);
          result = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culturelles.svg"; // Default icon if no match
          break;
      }
      return result;
    },

    // Display markers on the map with the correct icon
    displayMarkers(map) {
      if (!map) return;

      // Clear existing markers
      const existingMarkers = document.querySelectorAll('.experience-marker, .nearby-lodging-marker');
      existingMarkers.forEach(marker => marker.remove());

      // Display experience markers
      if (this.markers && this.markers.length > 0) {
        const selectedIcon = this.getIconForExperience(); // Get the correct icon based on currentExperiance

        console.log("Selected Icon: ", selectedIcon); // Log the selected icon URL for debugging

        this.markers.forEach((marker, index) => {
          let el = document.createElement('div');
          el.id = `experience-marker-${index}`;
          el.className = 'experience-marker';
          
          // Create image element for the marker
          let img = document.createElement('img');
          img.src = selectedIcon;
          img.style.width = '40px';
          img.style.height = '40px';
          img.style.cursor = 'pointer';
          el.appendChild(img);

          if (!this.isPhone) {
            const experience = this.lodgings.find(lodging => lodging.id === marker[2]);
            const experienceName = experience ? experience.name : `Experience ${marker[2]}`;

            // Create tooltip element
            let tooltip = document.createElement('div');
            tooltip.className = 'marker-tooltip';
            tooltip.textContent = experienceName;
            tooltip.style.display = 'none';
            el.appendChild(tooltip);

            // Add hover events for tooltip
            el.addEventListener('mouseenter', () => {
              tooltip.style.display = 'block';
            });

            el.addEventListener('mouseleave', () => {
              tooltip.style.display = 'none';
            });
          }

          // Add click event to select the marker
          el.addEventListener('click', () => {
            if (marker[2] && this.lodgings) {
              this.selectMarker(marker[2], 'experience');
              this.previousZoom = map.getZoom();
              this.previousCenter = map.getCenter();
              map.flyTo({
                center: [marker[0], marker[1]],
                zoom: 20
              });
            } else {
              // Fallback to original behavior
              this.$emit('markerSelected', index);
            }
          });
          
          // Add marker to the map
          new mapboxgl.Marker(el)
            .setLngLat([marker[0], marker[1]])
            .addTo(map);
        });
      }

      // Display nearby lodging markers
      if (this.nearbyLodgings && this.nearbyLodgings.length > 0) {
        this.nearbyLodgings.forEach((lodging, index) => {
          if (lodging.longitude && lodging.latitude) {
            let el = document.createElement('div');
            el.id = `nearby-lodging-${lodging.id}`;
            el.className = 'nearby-lodging-marker';

            let img = document.createElement('img');
            img.src = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/lodge_building.png";
            img.style.width = '30px';
            img.style.height = '30px';
            el.appendChild(img);

            // Add tooltip for nearby lodging
            if (!this.isPhone) {
              let tooltip = document.createElement('div');
              tooltip.className = 'marker-tooltip';
              tooltip.textContent = lodging.name || `Lodging ${lodging.id}`;
              tooltip.style.display = 'none';
              el.appendChild(tooltip);

              // Add hover events for tooltip
              el.addEventListener('mouseenter', () => {
                tooltip.style.display = 'block';
              });

              el.addEventListener('mouseleave', () => {
                tooltip.style.display = 'none';
              });
            }

            // Add click event to select the nearby lodging marker
            el.addEventListener('click', () => {
              this.selectMarker(lodging.id, 'lodging');
              this.previousZoom = map.getZoom();
              this.previousCenter = map.getCenter();
              map.flyTo({
                center: [lodging.longitude, lodging.latitude],
                zoom: 20
              });
            });

            // Add the marker to the map
            new mapboxgl.Marker(el)
              .setLngLat([lodging.longitude, lodging.latitude])
              .addTo(map);
          }
        });
      }

      // Fit map to show only experience markers (not nearby lodgings)
      if (this.markers && this.markers.length > 0) {
        const mapInstance = this.$refs.mapInstance.map; // Access Mapbox map instance
        if (mapInstance) {
          mapInstance.fitBounds(this.getBounds(), { padding: 50 });
        }
      }

      // Add geolocation control to the map
      const mapInstance = this.$refs.mapInstance.map;
      if (mapInstance) {
        mapInstance.addControl(new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true,
          showUserHeading: true
        }));
      }
    },

    // Get the bounds of all markers to fit the map view
    getBounds() {
      if (!this.markers || this.markers.length === 0) return null;
      
      let bounds = new mapboxgl.LngLatBounds();
      this.markers.forEach(marker => {
        bounds.extend([marker[0], marker[1]]);
      });
      return bounds;
    },

    selectMarker(markerId, type = 'experience') {
      console.log("Selecting marker:", markerId);
      this.selectedMarker = markerId;
      this.selectedMarkerType = type;
      if (type === 'lodging') {
        // For nearby lodgings, find from nearbyLodgings array
        this.selectedLodging = this.nearbyLodgings.find(lodging => lodging.id === parseInt(markerId));
      } else {
        // For experiences, find from lodgings array
        this.selectedLodging = this.lodgings.find(lodging => lodging.id === parseInt(markerId));
      }
      console.log("Selected marker state:", this.selectedMarker, this.selectedLodging);
    },

    unselectCardMap() {
      this.selectedMarker = null;
      this.selectedLodging = null;
      this.selectedMarkerType = 'experience';
      this.restoreMapState();
    },

    restoreMapState() {
      if (this.previousCenter && this.previousZoom !== null) {
        const map = this.$refs.mapInstance.map;
        map.flyTo({
          center: this.previousCenter,
          zoom: this.previousZoom,
        });
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#experience-map-show {
  .modal-mask {
    position: fixed;
    z-index: 1001;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    width: 100%;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 90%;
    height: 80vh;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    position: relative;
  }

  .closing {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1002;

    @media screen and (max-width: 768px) {      
      margin-right: 2rem;
    }
  }

  .close-btn-modal {
    width: 36px;
    height: 36px;
    background: #ddd;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    
    &:hover {
      background: #ccc;
    }
  }

  .experience-marker {
    cursor: pointer;
    position: relative;
    
    img {
      border-radius: 50%;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      transition: transform 0.2s ease;
      
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .nearby-lodging-marker {
    cursor: pointer;
    
    img {
      transition: transform 0.2s ease;
      
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 480px) {
  #experience-map-show {
    .modal-container {
      width: 100% !important;
      height: 100vh;
    }
    
    .experience-marker img {
      width: 30px !important;
      height: 30px !important;
    }
  }

  #map {
    width: 100% !important;
    height: 100vh !important;
  }

  .mapboxgl-canvas {
    width: 100% !important;
  }
  .mapboxgl-map {
    height: 100vh !important;
  }
}

.mapboxgl-canvas{
  width: 100% !important;
  height: 100% !important;
}
#map-lodging-show #map {
  width: 100% !important;
  height: 100vh !important;
}

#map-lodging-show .closing{
  margin: 1rem;
}
#map-lodging-show .modal-wrapper{
  width: 100%;
}

@media screen and (min-width: 481px) {
  .mapboxgl-map {
    height: 100vh !important;
  }
}

</style>

<style lang="scss">
#experience-map-show {
  .marker-tooltip {
    position: absolute;
    bottom: 55px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
  }

  .marker-tooltip::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.8);
  }
}
</style>